var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data text-center"},[_c('img',{attrs:{"src":require("../assets/img/ic_bg_car.png")}}),_c('div',[(_vm.tips)?_c('p',[_vm._v(_vm._s(_vm.tips))]):_vm._e(),_vm._t("noDataFont")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }